import React from "react";
import { FiArrowUp, FiArrowDown, FiMinus } from "react-icons/fi";

interface PreviousRatingIndicatorProps {
	currentScore: number;
	previousScore: number;
}

export const PreviousRatingIndicator: React.FC<
	PreviousRatingIndicatorProps
> = ({ previousScore, currentScore }) => {
	const delta = currentScore - previousScore;
	const isUp = delta > 0;
	const isDown = delta < 0;

	return (
		<div
			className="inline-flex items-center gap-1 text-xs"
			data-testid="previous-rating-indicator"
		>
			<span className="text-gray-400">
				{previousScore.toFixed(1)}
			</span>
			<span className="text-gray-300">→</span>
			<span className="font-medium text-gray-700">
				{currentScore.toFixed(1)}
			</span>
			{isUp && (
				<span className="inline-flex items-center text-green-600">
					<FiArrowUp className="h-3 w-3" />
					<span>+{delta.toFixed(1)}</span>
				</span>
			)}
			{isDown && (
				<span className="inline-flex items-center text-red-600">
					<FiArrowDown className="h-3 w-3" />
					<span>{delta.toFixed(1)}</span>
				</span>
			)}
			{!isUp && !isDown && (
				<span className="inline-flex items-center text-gray-400">
					<FiMinus className="h-3 w-3" />
					<span>0</span>
				</span>
			)}
		</div>
	);
};
